// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xO_D","toggleWrap":"styles_toggleWrap__A-DzE","content":"styles_content__3uhba","selectAreaCode":"styles_selectAreaCode__2WJsx"};